import React from "react";

export interface ScreenMarkerProps {
  id?: string;
  className?: string;
  height?: number;
}

export const ScreenMarker = ({ id = "screen", className = "", height = 11 }: ScreenMarkerProps) => {
  return (
    <marker
      id={id}
      className={className}
      viewBox="0 0 50 50"
      refX="0"
      refY={`${height / 2}`}
      markerWidth="50"
      markerHeight="50"
      orient="auto-start-reverse"
    >
      <rect width={1} height={height} />
    </marker>
  );
};
